import { ResponseSegmentCitations } from 'features/knowledgeDocumentViewer/components/advancedSearch/components/search/ResponseSegmentCitations'
import { useDocumentSearchData } from 'features/knowledgeDocumentViewer/components/advancedSearch/contexts/DocumentSearchDataContext'
import { getAgenticResponseBodyText } from 'features/knowledgeDocumentViewer/components/advancedSearch/utils/agenticSearchText'
import { buildCitationDocumentLookup } from 'features/knowledgeDocumentViewer/components/advancedSearch/utils/resolveCitationDocument'
import type { AgenticConversationResponseEvent } from 'features/knowledgeDocumentViewer/types'
import React, { useMemo } from 'react'
import styled from 'styled-components'

import { AgenticMarkdown } from './AgenticMarkdown'

const SegmentBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.375rem;
  min-width: 0;
`

const SegmentList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  min-width: 0;
`

export function CitedResponseSegments({
  event,
  ResponseText,
  wrapItems,
}: {
  event: AgenticConversationResponseEvent
  ResponseText: React.ComponentType<{ children: React.ReactNode }>
  wrapItems?: (items: React.ReactElement[]) => React.ReactNode
}): React.ReactElement | null {
  const { documentResults } = useDocumentSearchData()
  const citationLookup = useMemo(
    () => buildCitationDocumentLookup(documentResults),
    [documentResults]
  )

  if (event.response_segments?.length) {
    const items = event.response_segments.map((segment, segmentIndex) => (
      <SegmentBlock key={segmentIndex}>
        <ResponseText>
          <AgenticMarkdown>{segment.text}</AgenticMarkdown>
        </ResponseText>
        <ResponseSegmentCitations
          citations={segment.citations}
          citationLookup={citationLookup}
        />
      </SegmentBlock>
    ))
    if (wrapItems) return <>{wrapItems(items)}</>
    return <SegmentList>{items}</SegmentList>
  }

  const responseText = getAgenticResponseBodyText(event)
  if (!responseText) return null

  const fallback = (
    <ResponseText key='body'>
      <AgenticMarkdown>{responseText}</AgenticMarkdown>
    </ResponseText>
  )
  if (wrapItems) return <>{wrapItems([fallback])}</>
  return fallback
}
